import styles from "@css/modules/Resort.module.scss"
import React from "react"
import { Carousel } from "../../Animation/Carousel"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { Stars } from "../../Stars"
import { ArrowLeft } from "@css/icons/SVG"
import { SlideAppear } from "../../Animation/SlideAppear"

export function ResortReview({ reviews = [] }) {
    if (!reviews.length) {
        return null
    }
    const items = reviews.map((i, key) => {
        const img = i.review_image
        return (
            <div key={key}>
                <div className={styles.title}>
                    <LazyLoadImage useIntersectionObserver className={styles.userImage} src={img.url} alt={img.alternativeText} height={img.height} width={img.width} />
                    <div>
                        {i.title} <br />
                        {!!i.stars && <Stars className={styles.stars} current={i.stars} />}
                    </div>
                    <a href={i.link} aria-label="See review details">
                        <ArrowLeft className={styles.arrowRight} />
                    </a>
                </div>
                <div className={styles.reviewsDesc}>
                    {i.content}
                    <div className={styles.linkWrapper}>
                        <a href={i.link} className={styles.readMoreLink} target="_blank" rel="noreferrer">
                            {"Read the full review >"}
                        </a>
                    </div>
                </div>
            </div>
        )
    })
    return (
        <SlideAppear className={styles.reviewsRoot}>
            <Carousel
                heightProvider={<div className={styles.heightProvider}>{items}</div>}
                startAt={0}
                autoplayTime={0}
                classNames={{
                    itemActive: styles.itemActive,
                    item: styles.item,
                    itemNext: styles.itemNext,
                    itemPrev: styles.itemPrev,
                    root: styles.carousel,
                    dots: {
                        item: styles.dotItem,
                        root: styles.dotItemRoot,
                        active: styles.dotItemActive
                    }
                }}
                items={items}
            />
        </SlideAppear>
    )
}
